<template>
  <header class="header">
    <!-- 头部的第一行 -->
    <div class="top">
      <div class="container">
        <div class="loginList">
          <p>尚品汇欢迎您！</p>
          <p v-if="info.id">
            <span>欢迎，</span>
            <span>{{info.name}}</span>
            <a class="register" @click="logout">退出登录</a>
          </p>
          <p v-if="!info.id">
            <span>请</span>
            <router-link to="/login">登录</router-link>
            <router-link to="/register" class="register">免费注册</router-link>
            <!-- <router-link to="/test" class="register">测试</router-link> -->
          </p>
        </div>
        <div class="typeList">
          <router-link to="/myorder">我的订单</router-link>
          <router-link to="/shopcart">我的购物车</router-link>
          <a href="###">我的尚品汇</a>
          <a href="###">尚品汇会员</a>
          <a href="###">企业采购</a>
          <a href="###">关注尚品汇</a>
          <a href="###">合作招商</a>
          <a href="###">商家后台</a>
        </div>
      </div>
    </div>
    <!--头部第二行 搜索区域-->
    <div class="bottom">
      <h1 class="logoArea">
        <router-link class="logo" title="尚品汇" to="/home">
          <img src="./images/logo.png" alt="" />
        </router-link>
      </h1>
      <div class="searchArea">
        <form action="###" class="searchForm" @submit.prevent="toSearch">
          <input
            type="text"
            id="autocomplete"
            class="input-error input-xxlarge"
            v-model="keyword"
          />
          <button @click="toSearch" class="sui-btn btn-xlarge btn-danger" type="button">
            搜索
          </button>
        </form>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapState } from 'vuex';
  import {reqLogout} from '@/api'
  import {deleteToken} from '@/utils/auth'

  export default {
    name: "Header",
    data() {
      return {
        keyword:'' //用户输入的搜索关键词
      }
    },
    computed: {
      ...mapState('user',['info'])
    },
    methods: {
      //点击搜索按钮的回调 —— 跳转到Search路由
      toSearch(){
        // 尝试获取之前点击的分类信息
        const {query} = this.$route
        // 跳转到search路由
        this.$router.push({
          path:'/search',
          query:{
            ...query,
            keyword:this.keyword || undefined,
          }
        })
      },
      // 用于清空关键词
      clearKeyword(){
        this.keyword = ''
      },
      async logout(){
        if(confirm('确定退出吗？')){
          this.$store.dispatch('user/logout')
        }
      }
    },
    mounted() {
      // 组件一挂载就给$bus绑定一个clear-keyword事件，用于清空关键词
      this.$bus.$on('clear-keyword',this.clearKeyword)
    },
    beforeDestroy() {
      // 组件销毁之前解绑clear-keyword事件
      this.$bus.$off('clear-keyword')
    },
  };
</script>

<style lang="less" scoped>
.header {
  & > .top {
    background-color: #eaeaea;
    height: 30px;
    line-height: 30px;

    .container {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .loginList {
        float: left;

        p {
          float: left;
          margin-right: 10px;

          .register {
            border-left: 1px solid #b3aeae;
            padding: 0 5px;
            margin-left: 5px;
            cursor: pointer;
          }
        }
      }

      .typeList {
        float: right;

        a {
          padding: 0 10px;

          & + a {
            border-left: 1px solid #b3aeae;
          }
        }
      }
    }
  }

  & > .bottom {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;

    .logoArea {
      float: left;

      .logo {
        img {
          width: 175px;
          margin: 25px 45px;
        }
      }
    }

    .searchArea {
      float: right;
      margin-top: 35px;

      .searchForm {
        overflow: hidden;

        input {
          box-sizing: border-box;
          width: 490px;
          height: 32px;
          padding: 0px 4px;
          border: 2px solid #ea4a36;
          float: left;

          &:focus {
            outline: none;
          }
        }

        button {
          height: 32px;
          width: 68px;
          background-color: #ea4a36;
          border: none;
          color: #fff;
          float: left;
          cursor: pointer;

          &:focus {
            outline: none;
          }
        }
      }
    }
  }
}
</style>